(function(angular) {
    'use strict';
    angular.module('wtUi.wtBreadcrumb', ['ui.router', 'pascalprecht.translate']).config(moduleConfig);
    moduleConfig.$inject = ['$translateProvider', '$translatePartialLoaderProvider'];
    function moduleConfig($translateProvider, $translatePartialLoaderProvider) { // eslint-disable-line id-length
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{part}/{lang}.json'
        });
        $translateProvider.useLoaderCache('$templateCache');
        $translatePartialLoaderProvider.addPart('wt-ui/breadcrumb');
    }
})(window.angular);

